import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import { GET, POST, httpOk } from 'helpers/api'

function QuickSupplierModal({ show, onClose, onCreated }) {
	const { t } = useTranslation()
	const [data, setData] = useState({})
	const [supplierTypes, setSupplierTypes] = useState([])

	async function createSupplier(e) {
		e.preventDefault()

		const response = await POST('/suppliers', data, { loader: true })
		if (httpOk(response)) {
			onCreated?.(response.data)
			setData({})
			onClose?.()
		}
	}

	async function getSupplierTypes() {
		const response = await GET('/helper/supplier-types')
		if (httpOk(response)) setSupplierTypes(response.data)
	}

	useEffect(() => {
		if (show && !supplierTypes.length) getSupplierTypes()
		if (!show) setData({})
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={show} animation={false} centered
			dialogClassName="update-modal-width"
			onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title>{t('create')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={createSupplier} autoComplete="off">
					<div className="form-group">
						<label>{t('system_name')}<span className="required-mark">*</span></label>
						<input type="text" className="form-control"
							value={data.name ?? ''}
							onChange={(e) => setData({ ...data, name: e.target.value })} />
					</div>
					<div className="form-group">
						<label>{t('type')}</label>
						<Select
							isClearable
							options={supplierTypes}
							value={supplierTypes.find(option => option.id === data.supplier_type_id) || ''}
							onChange={(option) => setData({ ...data, supplier_type_id: option ? option.id : null })}
							placeholder=""
							noOptionsMessage={() => t('list_empty')}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
						/>
					</div>
					<div className="form-group">
						<label>{t('phone')}</label>
						<input type="number" className="form-control"
							value={data.phone ?? ''}
							onChange={(e) => setData({ ...data, phone: e.target.value })} />
					</div>
					<div className="form-group">
						<label>{t('company')}</label>
						<input type="text" className="form-control"
							value={data.company_name ?? ''}
							onChange={(e) => setData({ ...data, company_name: e.target.value })} />
					</div>
					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={onClose}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100"
							disabled={!data.name}>
							{t('save')}
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	)
}

export default QuickSupplierModal
